<template>
  <section class="s-price-sheet">
    <div class="s-price-sheet__cont">
      <div class="s-price-sheet__header">
        <div class="s-breadcrumb-target"></div>

        <h1 class="s-price-sheet__title">{{ dictionary.headerTitle }}</h1>

        <div class="s-price-sheet__filters">
          <div class="s-price-sheet__date">
            <date-picker
              :label="dictionary.datepickerLabel"
              :date-from="dateFrom"
              :date-to="dateTo"
              @changed-date="getDate"></date-picker>
          </div>

          <div class="s-price-sheet__categories">
            <filters
              :filters-data="filtersData"
              :active-filter="activeFilterKey"
              :title="dictionary.filtersTitle"
              @changed-duration="getNewSelectedFilter"></filters>
          </div>
        </div>
      </div>

      <div class="s-price-sheet__body">
        <Loader v-if="isLoading" display="absolute"></Loader>

        <Alert v-if="errorMsgs.length" type="danger" :messages="errorMsgs" />

        <div
          v-if="activeFilterKey !== 'all' && !errorMsgs.length"
          class="s-price-sheet__results">
          <div class="s-price-sheet__results__conts">
            <template v-for="item in records" :key="item.id">
              <div
                v-for="f in item.funds"
                :key="f.id"
                class="s-price-sheet__results__item">
                <a :href="f.url" class="b-article">
                  <div class="b-article__body">
                    <div class="b-article__name">{{ f.name }}</div>
                    <div class="b-article__data">
                      <span v-if="activeFilterKey === 'kathariTimi'">
                        {{ f.kathariTimi }}
                      </span>
                      <span v-if="activeFilterKey === 'imerisiaMetavoli'">
                        {{ f.imerisiaMetavoli }}
                      </span>
                      <span v-if="activeFilterKey === 'metavoliApoTinArxi'">
                        {{ f.metavoliApoTinArxi }}
                      </span>
                      <span v-if="activeFilterKey === 'katharoEnergitiko'">
                        {{ f.katharoEnergitiko }}
                      </span>
                      <span v-if="activeFilterKey === 'timiDiathesis'">
                        {{ f.timiDiathesis }}
                      </span>
                      <span v-if="activeFilterKey === 'timiExagoras'">
                        {{ f.timiExagoras }}
                      </span>
                      <span v-if="activeFilterKey === 'arithmosMeridiwn'">
                        {{ f.arithmosMeridiwn }}
                      </span>
                    </div>
                  </div>

                  <i class="icon-arrow-right b-article__btn"></i>
                </a>
              </div>
            </template>
          </div>
        </div>

        <template v-if="activeFilterKey === 'all' && !errorMsgs.length">
          <div class="s-price-sheet__table">
            <div class="s-price-sheet__table__header">
              <div
                v-for="filter in filtersData"
                :key="filter.id"
                class="s-price-sheet__table__td"
                :class="
                  filter.key === 'all' ? 's-price-sheet__table__td--name' : ''
                ">
                {{ filter.label }}
              </div>
            </div>

            <template v-for="item in records" :key="item.id">
              <div class="s-price-sheet__table__tr">
                <div class="s-price-sheet__table__category">
                  {{ item.categoryName }}
                </div>
                <div class="s-price-sheet__table__data">
                  <div
                    v-for="f in item.funds"
                    :key="f.id"
                    class="s-price-sheet__table__row">
                    <div
                      class="s-price-sheet__table__td s-price-sheet__table__td--name">
                      {{ f.name }}
                    </div>
                    <div class="s-price-sheet__table__td">
                      {{ f.kathariTimi }}
                    </div>
                    <div class="s-price-sheet__table__td">
                      {{ f.imerisiaMetavoli }}
                    </div>
                    <div class="s-price-sheet__table__td">
                      {{ f.metavoliApoTinArxi }}
                    </div>
                    <div class="s-price-sheet__table__td">
                      {{ f.katharoEnergitiko }}
                    </div>
                    <div class="s-price-sheet__table__td">
                      {{ f.timiDiathesis }}
                    </div>
                    <div class="s-price-sheet__table__td">
                      {{ f.timiExagoras }}
                    </div>
                    <div class="s-price-sheet__table__td">
                      {{ f.arithmosMeridiwn }}
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>

          <div class="s-price-sheet__table s-price-sheet__table--mob">
            <div
              v-for="item in records"
              :key="item.id"
              class="s-price-sheet__table__card">
              <div class="s-price-sheet__table__category">
                {{ item.categoryName }}
              </div>

              <div
                v-for="f in item.funds"
                :key="f.id"
                class="s-price-sheet__table__card__body">
                <div class="s-price-sheet__table__title">
                  {{ f.name }}
                </div>
                <div class="s-price-sheet__table__card__columns">
                  <div class="s-price-sheet__table__card__row">
                    <span>{{ Object.values(filtersData)[1].label }}</span>
                    <span>{{ f.kathariTimi }}</span>
                  </div>
                  <div class="s-price-sheet__table__card__row">
                    <span>{{ Object.values(filtersData)[2].label }}</span>
                    <span>{{ f.imerisiaMetavoli }}</span>
                  </div>
                  <div class="s-price-sheet__table__card__row">
                    <span>{{ Object.values(filtersData)[3].label }}</span>
                    <span>{{ f.katharoEnergitiko }}</span>
                  </div>
                  <div class="s-price-sheet__table__card__row">
                    <span>{{ Object.values(filtersData)[4].label }}</span>
                    <span>{{ f.timiDiathesis }}</span>
                  </div>
                  <div class="s-price-sheet__table__card__row">
                    <span>{{ Object.values(filtersData)[5].label }}</span>
                    <span>{{ f.timiExagoras }}</span>
                  </div>
                  <div class="s-price-sheet__table__card__row">
                    <span>{{ Object.values(filtersData)[6].label }}</span>
                    <span>{{ f.arithmosMeridiwn }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>

        <div class="s-price-sheet__table__cta">
          <a :href="pdfUrl" download="" class="btn btn-icon-outline-blue">
            <span>{{ dictionary.downloadBtnLabel }}</span>
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from 'axios'
import Alert from '../components/common/Alert.vue'
import Loader from '../components/common/Loader.vue'
import * as lib from '../../lib/lib'
import Filters from '../components/Filters.vue'
import DatePicker from '../components/DatePicker.vue'

export default {
  components: {
    Alert,
    Filters,
    Loader,
    DatePicker,
  },

  data() {
    return {
      // default

      isLoading: false,
      errorMsgs: [],
      filtersData: [],
      activeFilterKey: '',
      selectedDate: '',
      records: [],
      pdfUrl: '',
      dateFrom: '',
      dateTo: '',
      // downloadBtnLabel: '',
    }
  },

  mounted() {
    const { filters, dateFrom, dateTo, pdfUrl} = lib.getData('priceSheetData')
    this.filtersData = filters
    this.dateFrom = dateFrom
    this.dateTo = dateTo
    this.pdfUrl = pdfUrl

    this.activeFilter()
  },

  methods: {
    activeFilter() {
      if (this.filtersData) {
        this.activeFilterKey = this.filtersData.find(
          (filter) => filter.isSelected
        ).key

        if (this.activeFilterKey) {
          this.fetchData()
        }
      }
    },

    fetchData() {
      this.isLoading = true

      axios
        .post(this.configuration.dataHandler, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-Requested-With': 'XMLHttpRequest',
          },
          filter: this.activeFilterKey,
          date: this.selectedDate,
        })
        .then((response) => {
          const { hasError, errorMessages, data } = response.data

          // response has error
          if (hasError) {
            this.handleError(errorMessages)
            return false
          }

          this.isLoading = false
          this.records = data.records         

          this.$nextTick(() => {
            this.handleSuccess()
          })          
        })
        .catch((errors) => {
          console.error(errors)
        })
    },

    getNewSelectedFilter(activeKey) {    
      this.activeFilterKey = activeKey
     // this.fetchData()
    },

    getDate(date) {      
      this.selectedDate = date
      this.fetchData()
    },

    handleError(messages) {
      this.errorMsgs = messages
      this.isLoading = false
    },

    handleSuccess() {
      this.errorMsgs = []
      this.isLoading = false
    },
  },
}
</script>
